import React from 'react';
import { BubbleButton } from './styles';

const ChatIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

function ChatBubble({ isOpen, onClick }) {
  return (
    <BubbleButton onClick={onClick} aria-label={isOpen ? 'Close chat' : 'Open chat'}>
      {isOpen ? <CloseIcon /> : <ChatIcon />}
    </BubbleButton>
  );
}

export default ChatBubble;
